import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints } from 'src/api/APIEndpoints';
import { archLevel } from 'src/data/config';
import { IStudies } from 'src/types/Utils';
import { formatString } from 'src/util/STR';
import { tsdaBaseQuery } from '../services/baseQuery';
import { baseQueryUtils } from './baseQueryUtils';
import { workareaBaseQuery } from './workArearBaseQuery';

export const utilsApi = createApi({
  baseQuery: archLevel == 'sponsor' ? baseQueryUtils : tsdaBaseQuery,
  // baseQuery: baseQueryUtils,
  reducerPath: 'utilsApi',
  endpoints: builder => ({
    getStudies: builder.query<IStudies, void>({
      query: () => ({
        url: `${formatString(endPoints.Utils.selectStudies)}?application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getCountries: builder.query<IStudies, string>({
      query: studyID => ({
        url: `${formatString(endPoints.Utils.selectCountries)}?study_id=${studyID}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getSites: builder.query<IStudies, { currentStudy: string; currentCountry: string }>({
      query: ({ currentStudy, currentCountry }) => ({
        url: `${formatString(
          endPoints.Utils.selectSites
        )}?study_id=${currentStudy}&country=${currentCountry}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getServerDateTime: builder.mutation<void, void>({
      query: () => ({
        url: formatString(endPoints.Utils.serverDateTime),
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});
export const utilsSysAdminApi = createApi({
  baseQuery: workareaBaseQuery,
  reducerPath: 'utilsSysAdminApi',
  endpoints: builder => ({
    getAssignees: builder.mutation<any, any>({
      query: ({ client_name, data }) => ({
        url: formatString(endPoints.Utils.assignees, {
          key: 'client_name',
          value: client_name
        }),
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    allAssignees: builder.query<IStudies, void>({
      query: () => ({
        url: formatString(endPoints.Utils.allAssignees),
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const { useLazyGetStudiesQuery, useGetCountriesQuery, useGetSitesQuery, useGetServerDateTimeMutation, useLazyGetSitesQuery } =
  utilsApi;
export const { useGetAssigneesMutation, useAllAssigneesQuery } = utilsSysAdminApi;
